// extracted by mini-css-extract-plugin
module.exports = {"hidden":"styles__hidden___3vbrT"};